import React from 'react';

import { orderAutomationApi } from 'api';
import { QueryKey, OrderAutomationFilterTypes } from 'enums';
import { usePartialQuery, useUser } from 'hooks';

import { ManageOrderAutomationList } from '../ManageOrderAutomationList';

export const TemplateErrorHandledOrderAutomation: React.FC = () => {
  const { role } = useUser();

  const queryResult = usePartialQuery(
    QueryKey.TemplateErrorHandledOrderAutomation,
    orderAutomationApi.getMessagesPaginatedAsRole(
      role,
      OrderAutomationFilterTypes.TemplateErrorHandled,
    ),
    { useCachedCount: true },
  );

  return <ManageOrderAutomationList queryResult={queryResult} />;
};
